import {IGridStatus} from '../../ap-interface/interfaces/ap-grid-status.interface';
import IGuid = System.IGuid;
import IMachine = Data.DocuContext.Machine.IMachine;

export enum MachinesPagerAction {
  Active = 0,
  Inactive = 1,
  Deleted = 2
}

export interface IMachinesGridData {
  Id: IGuid;
  Status: IGridStatus;
  Name: string;
  Sign: string;
  KindName: string;
  InstrumentName: string;
  DriverName: string;
  SourceItem: IMachine;
}
